// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"a9acc2eb","233":"9ee23fa4","369":"b808a59f","936":"25eb7461"}[chunkId] + ".css";
};